import React, { useState, useEffect } from "react"; //useCallback
import { global_var } from "../../services/cs-lab-config";
// import IdeHeader from "./ide-header";
import { useParams, useNavigate } from "react-router-dom";
import { getIdeProjectDetails } from "../../services/ide-apis";
import { message } from "antd";
import cybersquareCat from "../../assets/images/cybercat.gif";
import { useLocation } from 'react-router-dom';

const FlowCircuitIde = () => {
  document.title = "CS Lab | Flow Circuit IDE";

  let { ideProjectId } = useParams();

  // const [ideProjectDetails, setIdeProjectDetails] = useState(undefined);
  // const updateProjectDetails = useCallback((updatedProject) => {
    // setIdeProjectDetails({ ...updatedProject });
  // }, []);
  const [isLoading, setShowSpinner] = useState(true); // State to track loading status
  const [flowCircuitUrl, setFlowCircuitUrl] = useState(undefined);
  const [fkResourceId, setFkResourceId] = useState(undefined);
  const [fkActivityMapping, setFkActivityMapping] = useState(undefined);
  const [fkUserActivityMappingId, setFkUserActivityMappingId] = useState(undefined);
  const [isEval, setIsEval] = useState(undefined);
  const [isLoadingProgress, setisLoadingProgress] = useState(true);

  const location = useLocation();
  const navigate = useNavigate();
  const [userToken] = useState(() => sessionStorage.getItem('token'));

  useEffect(() => {
    const queryParams = new URLSearchParams(location.search);

    if(queryParams.get('isEval')){
      setIsEval(queryParams.get('isEval'))
    }

    if(queryParams.get('fkResourceId')){
      setFkResourceId(queryParams.get('fkResourceId'))
    }

    if(queryParams.get('fkActivityMapping')){
      setFkActivityMapping(queryParams.get('fkActivityMapping'))
    }

    if(queryParams.get('fkUserActivityMappingId')){
      setFkUserActivityMappingId(queryParams.get('fkUserActivityMappingId'))
    }
    setTimeout(() => {
      setisLoadingProgress(false)
    }, 500);

    const handler_fn = (event) => {
      if (event.data.type === "gobackClicked" && event.data.source === "cs-flow-circuit") {
        navigate(-1);
        return;
      }
      if (event.data.from === "flow_circuit") {
          if (event.data.response) {
            const response = JSON.parse(event.data.response)
            if (response.ideProjectId && response.statusCode === 200) {
              getIdeProjectDetails(response.ideProjectId).then((response) => {
                response = response.data;
                if (response.statusCode === 200) {
                  // setIdeProjectDetails(response.projectDetails);
                }
              });

            }
          }
      }
    };

    window.addEventListener('message', handler_fn);

    return () => {
        window.removeEventListener('message', handler_fn);
    };

  },[location, navigate])

  useEffect(() => {
    if (ideProjectId) {
      getIdeProjectDetails(ideProjectId).then((response) => {
        response = response.data;

        if (response.statusCode === 200) {
          if (
            response.projectDetails.fkUserLoginId ===
              global_var.user_login_id ||
            global_var.role_id !== global_var.STUDENT_ROLE_ID
          ) {
            // setIdeProjectDetails(response.projectDetails);
          } else {
            message.error("Your session expired. Please login again");
          }
        } else {
          message.error(response.message);
        }
      });

      if ((isEval? isEval === "true": false) && !fkResourceId) {
        setFlowCircuitUrl(
          global_var.FLOW_CIRCUIT_ENDPOINT +
            "?token=" +
            userToken +
            "&ideProjectId=" +
            ideProjectId +
            "&isEvaluate=true" +
            "&hidden-cslab-ideheader=true"
        );
      }else if ((isEval? isEval === "true": false) && fkResourceId) {
        setFlowCircuitUrl(
          global_var.FLOW_CIRCUIT_ENDPOINT +
            "?token=" +
            userToken +
            "&ideProjectId=" +
            ideProjectId +
            "&isEvaluate=true" +
            "&fkResourceId=" +
            fkResourceId +
            "&fkActivityMapping=" +
            fkActivityMapping +
            "&fkUserActivityMappingId=" +
            fkUserActivityMappingId + 
            "&hidden-cslab-ideheader=true"
        );

      }
      else if (!isEval && fkResourceId) {
        setFlowCircuitUrl(
          global_var.FLOW_CIRCUIT_ENDPOINT +
            "?token=" +
            userToken +
            "&ideProjectId=" +
            ideProjectId +
           "&fkResourceId=" + fkResourceId + "&fkActivityMapping=" + fkActivityMapping + "&fkUserActivityMappingId=" + fkUserActivityMappingId + "&origin=lab_assignment" +
           "&hiddden-cslab-ideheader=true"
        );
      }
      else {
        setFlowCircuitUrl(
          global_var.FLOW_CIRCUIT_ENDPOINT +
            "?token=" +
            userToken +
            "&ideProjectId=" +
            ideProjectId + 
            "&hidden-cslab-ideheader=true"
        );
      }
    }else if(fkResourceId && fkActivityMapping){
      setFlowCircuitUrl(global_var.FLOW_CIRCUIT_ENDPOINT + "?fkResourceId=" + fkResourceId + "&fkActivityMapping=" + fkActivityMapping + "&fkUserActivityMappingId=" + fkUserActivityMappingId + "&origin=lab_assignment&token=" + userToken + "&hidden-cslab-ideheader=true");
    } else {
      setFlowCircuitUrl(global_var.FLOW_CIRCUIT_ENDPOINT + "?token=" + userToken + "&hidden-cslab-ideheader=true");
    }
  }, [ideProjectId, userToken, isEval, fkResourceId, fkActivityMapping, fkUserActivityMappingId]);

  // Function to handle iframe load event
  const handleIframeLoad = () => {
    setShowSpinner(false); // Set loading status to false when iframe content is loaded
  };


  return (
    <div className="container-fluid p-0">
      <div className="row">
        <div className="col">
          {/* <IdeHeader
            headerName="Flow Circuit IDE"
            hidePortfolio={true}
            ideProjectDetails={ideProjectDetails}
            fkResourceId={fkResourceId}
            onUpdateProjectDetails={updateProjectDetails}
          /> */}
          {isLoading && (
            <div
              style={{
                textAlign: "center",
                marginTop: "10rem",
              }}
            >
              <img
                src={cybersquareCat}
                width="200px"
                alt="Loader"
                height="120px"
              />
              <div className="text-secondary font-weight-bold poppins-regular">Please wait !! Your project is loading...</div>
            </div>
          )}

          <div className="row">
            <div className="col">
              {!isLoadingProgress && (
                <iframe
                  id="flowCircuitIframe"
                  src={flowCircuitUrl}
                  title="flow-circuit"
                  allow='camera; microphone'
                  onLoad={handleIframeLoad} // Attach the load event handler
                  style={{
                    width: "100%",
                    height: "90vh",
                    border: "none",
                    marginTop: "5px",
                  }}
                ></iframe>
              )}
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};
export default FlowCircuitIde;
